import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { ResourceManagerService } from '@barthauer/abc/core/resources';
import { ResourceSet } from 'libs/abc/core/resources/src/lib/resource-set';
import { Observable } from 'rxjs';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'abc-opera-workmode-selection',
  templateUrl: './workmode-selection.component.html',
  styleUrls: ['./workmode-selection.component.css'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WorkmodeSelectionComponent implements OnInit {
  public resAsync: Promise<ResourceSet>;
  public countTicket: number;
  public hasTicket$: Observable<boolean>;
  protected isTicketLicensed: boolean;
  public res = ResourceSet.Empty;
  constructor(
    private dataService: DataService,
    private resourceService: ResourceManagerService,
    private cd: ChangeDetectorRef,
  ) {
    this.resAsync = this.resourceService.getResourceSet('abc-maintenance-opera');
  }

  async ngOnInit() {
    this.res = await this.resAsync;

    this.isTicketLicensed = await this.dataService.isTicketLicensed();
    this.cd.detectChanges();
  }
}
